import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { NameSpace } from '../../const';
import { ReportFactory } from '../../types/state';
import { FetchReportFactoryParams, FetchReportFactorySuccessPayload } from '../../types/request';
import { buildReportFactory } from '../../utils/data-table';

const initialState: ReportFactory = {
  data: null,
  fetchingStatusReportFactory: false,
  error: null
};

export const dataReportFactory = createSlice({
  name: NameSpace.ReportFactory,
  initialState,
  reducers: {
    fetchReportFactoryRequest: (state, payload: PayloadAction<FetchReportFactoryParams>) => {
      state.fetchingStatusReportFactory = true;
      state.error = null;
    },
    fetchReportFactorySuccess: (state, action: PayloadAction<FetchReportFactorySuccessPayload>) => {
      state.fetchingStatusReportFactory = false;
      const data = action.payload;
      state.data = buildReportFactory(data);
    },
    fetchReportFactoryFailure: (state, action) => {
      state.fetchingStatusReportFactory = false;
      state.error = action.payload;
    },
  },
});

export const { fetchReportFactoryRequest, fetchReportFactorySuccess, fetchReportFactoryFailure } = dataReportFactory.actions;
